import BaseFeature from '../../foundation/base/base';

class CourseDetails extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();

		this.el = element;
		this.map = this.el;
		this.body = window.features.dom.body;
		this.showMore = this.el.querySelector('[data-js="showMore"]');
		this.showLess = this.el.querySelector('[data-js="showLess"]');
		this.sessionRows = this.el.querySelectorAll('[data-js="sessionRows"]');
		this.sessionRowsHisde = this.el.querySelectorAll('[data-js="sessionRows"]');
		this.addClick();
	}

	addClick() {
		if (this.showMore) {
			this.showMore.addEventListener('click', () => {
				this.showLess.classList.add('is-temporary');
				this.showMore.classList.add('is-temporary');

				this.sessionRows.forEach((el) => {
					el.classList.add('is-temporary');
				});
			});

			// Accessibility with keyboard
			this.showMore.addEventListener('keydown', (event) => {
				if (event.code === 'Space' || event.code === 'Enter') {
					this.showLess.classList.add('is-temporary');
					this.showMore.classList.add('is-temporary');

					this.sessionRows.forEach((el) => {
						el.classList.add('is-temporary');
					});
				}
			});
		}
		if (this.showLess) {
			this.showLess.addEventListener('click', () => {
				this.showLess.classList.remove('is-temporary');
				this.showMore.classList.remove('is-temporary');

				this.sessionRows.forEach((el) => {
					el.classList.remove('is-temporary');
				});
			});
			this.showLess.addEventListener('keydown', (event) => {
				if (event.code === 'Space' || event.code === 'Enter') {
					this.showLess.classList.remove('is-temporary');
					this.showMore.classList.remove('is-temporary');

					this.sessionRows.forEach((el) => {
						el.classList.remove('is-temporary');
					});
				}
			});
		}
	}
}

export default CourseDetails;
